<template>
  <div class="loading-bg active">
    <div class="loading-box">
      <div class="loading-txt">잠시만 기다려 주세요.</div>
      <div class="loading-img"></div>
    </div>
  </div>
</template>

<script>
export default {};
</script>

<style lang="scss" scoped>
</style>